import React, { useRef } from "react";
import { motion, AnimatePresence } from "motion/react";
import ReactDOM from "react-dom";
import closeIcon from "../../../assets/images/close_icon.svg";
import warningIcon from "../../../assets/images/warning_icon.png";
import useRipple from "../../../hooks/useRipple";
import "../../../hooks/useRipple.css";
import "./Popup.css";
import "./WarningPopup.css";

const Popup = ({
  isVisible,
  onClose,
  children,
  popupStyle,
  title,
  handelPrimery,
  handelSecondry,
  FirstBtnTitle,
  SecondBtnTitle,
  primaryButtonDisabled,
  isWarning,
  style,
  showSubtitle = true,
  contentClassName,
}) => {
  const primaryBtnRef = useRef(null);
  const secondaryBtnRef = useRef(null);

  useRipple(primaryBtnRef);
  useRipple(secondaryBtnRef);
  // Check for reduced motion preference
  const prefersReducedMotion =
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Animation variants for overlay
  const overlayVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: prefersReducedMotion ? 0 : 0.3 },
    },
    exit: {
      opacity: 0,
      transition: { duration: prefersReducedMotion ? 0 : 0.3 },
    },
  };

  // Animation variants for modal content
  const modalVariants = {
    hidden: {
      opacity: 0,
      y: prefersReducedMotion ? 0 : 24,
      scale: prefersReducedMotion ? 1 : 0.96,
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: prefersReducedMotion ? 0 : 0.35,
        ease: "easeOut",
      },
    },
    exit: {
      opacity: 0,
      y: prefersReducedMotion ? 0 : -24,
      scale: prefersReducedMotion ? 1 : 0.96,
      transition: {
        duration: prefersReducedMotion ? 0 : 0.3,
        ease: "easeIn",
      },
    },
  };

  const popupMarkup = (
    <AnimatePresence mode="wait">
      {isVisible && (
        <>
          <motion.div
            className="popup-overlay backdrop"
            onClick={onClose}
            variants={overlayVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          />

          <div className="popup-viewport" role="presentation">
            <motion.div
              className={`popup ${isWarning ? "warning-popup" : ""}`}
              style={popupStyle}
              variants={modalVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
            >
              {isWarning && (
                <div className="warning-icon-container">
                  <img
                    src={warningIcon}
                    alt="warning"
                    className="warning-icon"
                  />
                </div>
              )}
              <h4 className={`popupTitel ${isWarning ? "warning-title" : ""}`}>
                {title}
              </h4>
              {isWarning && showSubtitle && (
                <h5 className="warning-subtitle">Are you sure?</h5>
              )}
              <button className="close-button" onClick={onClose}>
                <img src={closeIcon} alt="close button" />
              </button>
              <div className={`popup-content ${contentClassName || ""}`.trim()}>
                {children}
              </div>
              {(FirstBtnTitle ||
                SecondBtnTitle ||
                handelPrimery ||
                handelSecondry) && (
                <div className="popbtnCont">
                  {FirstBtnTitle && (
                    <button
                      className={isWarning ? "warning-no-btn" : "light_popbtn"}
                      onClick={handelSecondry}
                      ref={secondaryBtnRef}
                    >
                      {FirstBtnTitle}
                    </button>
                  )}
                  {SecondBtnTitle && (
                    <button
                      className={isWarning ? "warning-yes-btn" : "dark_btn"}
                      onClick={handelPrimery}
                      disabled={primaryButtonDisabled}
                      ref={primaryBtnRef}
                      style={
                        primaryButtonDisabled
                          ? { opacity: 0.5, cursor: "not-allowed" }
                          : {}
                      }
                    >
                      {SecondBtnTitle}
                    </button>
                  )}
                </div>
              )}
            </motion.div>
          </div>
        </>
      )}
    </AnimatePresence>
  );

  if (typeof document !== "undefined") {
    return ReactDOM.createPortal(popupMarkup, document.body);
  }

  return popupMarkup;
};

export default Popup;
